import { Stylis } from 'emotion-utils';
import { StyleSheet } from '@emotion/sheet';
import { isBrowser } from '@emotion/utils';

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';
function createRuleSheetPlugin(insertRule) {
  function toSheet(block) {
    if (block) {
      insertRule(block + '}');
    }
  }

  return function ruleSheet(context, content, selectors, parents, line, column, length, at, depth) {
    switch (context) {
      case 2:
        if (at === 0) return content + delimiter;
        break;
      // at-rule

      case 3:
        switch (at) {
          // @font-face, @page
          case 102:
          case 112:
            {
              insertRule(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + delimiter;
            }
        }

      case -2:
        {
          content.split(needle).forEach(toSheet);
        }
    }
  };
}

var stylis = new Stylis({
  keyframe: false,
  global: false,
  semicolon: true
});
var current;
var insertionPlugin = createRuleSheetPlugin(function (rule) {
  current.push(rule);
});

var returnFullPlugin = function returnFullPlugin(context) {
  if (context === -1) {
    current = [];
  }

  if (context === -2) {
    return current;
  }
};

stylis.use(insertionPlugin)(returnFullPlugin);

var createCache = function createCache() {
  var context = {
    stylis: stylis,
    sheet: new StyleSheet({
      key: ''
    }),
    inserted: {},
    registered: {},
    theme: {}
  };

  if (isBrowser) {
    context.sheet.inject();
  }

  return context;
};

export default createCache;
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/cache/dist/index.es.js